<section class="manual-settings" aria-labelledby="keyaction-settings-heading">
  <div class="section-header">
    <div>
      <h2 id="keyaction-settings-heading">重点強化KeyActionの設定</h2>
      <p>
        登録されている全オペレーターの当月実績を確認し、重点項目を最大3つまで設定します。
      </p>
    </div>
    @if (settings != null) {
      <span class="count-chip" role="status">
        {{ countText }}
      </span>
    }
  </div>

  @if (isLoading) {
    <div class="status-panel" aria-live="polite">
      <mat-spinner diameter="28" aria-hidden="true"></mat-spinner>
      <span>オペレーター設定を読み込んでいます。</span>
    </div>
  } @else if (settings == null) {
    <div class="status-panel error-panel" role="alert">
      <mat-icon aria-hidden="true">error_outline</mat-icon>
      <span>{{ loadErrorMessage }}</span>
      <button class="btn btn-secondary" type="button" (click)="retry()">
        再試行
      </button>
    </div>
  } @else {
    <div class="keyaction-list-wrap">
      <div class="keyaction-list-head">
        <h3>オペレーター</h3>
        <label class="keyaction-sort">
          <span>並び替え</span>
          <select
            [(ngModel)]="sort"
            [disabled]="savingUserId != null"
            (ngModelChange)="onSortChanged()"
          >
            <option value="default">一覧画面と同じ順</option>
            <option value="actual-asc">実績が低い順</option>
            <option value="actual-desc">実績が高い順</option>
            <option value="gap">目標未達差が大きい順</option>
          </select>
        </label>
      </div>

      <label class="keyaction-search">
        <mat-icon aria-hidden="true">search</mat-icon>
        <span class="sr-only">オペレーター検索</span>
        <input
          type="search"
          [formControl]="searchControl"
          placeholder="氏名で検索"
          autocomplete="off"
        />
      </label>

      @if (saveErrorMessage) {
        <p class="save-error" role="alert">
          {{ saveErrorMessage }}
        </p>
      }

      @if (rows.length === 0) {
        <div class="empty-list">
          {{
            isSearching
              ? '検索条件に一致するオペレーターはいません。'
              : '登録されているオペレーターはいません。'
          }}
        </div>
      } @else {
        <div class="keyaction-operator-list">
          @for (viewModel of rows; track viewModel.row.userId) {
            <article
              class="keyaction-operator-item"
              [attr.data-user-id]="viewModel.row.userId"
            >
              <div class="keyaction-operator-head">
                <div>
                  <h4>{{ viewModel.row.userName }}</h4>
                  <span class="keyaction-operator-meta">{{
                    viewModel.metaText
                  }}</span>
                </div>
                <div class="keyaction-operator-actions">
                  <button
                    class="btn btn-secondary btn-sm edit-button"
                    type="button"
                    [attr.aria-expanded]="
                      editingUserId === viewModel.row.userId
                    "
                    [attr.aria-label]="
                      viewModel.row.userName + 'さんの設定を編集'
                    "
                    [disabled]="savingUserId != null"
                    (click)="startEditing(viewModel)"
                  >
                    編集
                  </button>
                </div>
              </div>
              <div class="keyaction-operator-summary">
                <div class="keyaction-metrics">
                  @for (metric of viewModel.metrics; track metric.itemId) {
                    <div class="keyaction-metric">
                      <span>{{ metric.label }}</span>
                      @if (metric.actualRate == null) {
                        <strong class="empty">実績 -</strong>
                      } @else {
                        <strong>
                          実績{{ metric.actualRateText }}%
                          @if (metric.gap != null) {
                            （目標比<span [class]="metric.gapClass">{{
                              metric.gapText
                            }}</span
                            >）
                          }
                        </strong>
                      }
                    </div>
                  }
                </div>
                @if (viewModel.selectedKeyActions.length === 0) {
                  <div class="keyaction-unset">未設定</div>
                } @else {
                  <div class="keyaction-values">
                    @for (
                      keyAction of viewModel.selectedKeyActions;
                      track keyAction.id
                    ) {
                      <div class="keyaction-value">
                        <div class="keyaction-value-copy">
                          <strong
                            ><span class="ka-no">{{ keyAction.label }}</span
                            >{{ keyAction.name }}</strong
                          >
                          <small>
                            {{ scoreCountLabel }}
                            <b
                              class="keyaction-value-score"
                              [class.low]="keyAction.lowScore"
                              >{{ keyAction.averageScoreText }}</b
                            >
                            / 5
                          </small>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>

              @if (editingUserId === viewModel.row.userId) {
                <div class="keyaction-inline-editor">
                  <app-key-action-selector
                    class="inline-selector"
                    [options]="editorKeyActions"
                    [description]="scoreCountDescription"
                    [ariaLabel]="
                      viewModel.row.userName + 'の重点強化KeyAction一覧'
                    "
                    [readonly]="savingUserId != null"
                    (selectedIdsChange)="onEditorSelectionChanged($event)"
                  />
                  <div class="keyaction-inline-actions">
                    <button
                      class="btn btn-secondary cancel-button"
                      type="button"
                      [disabled]="savingUserId != null"
                      (click)="cancelEditing()"
                    >
                      キャンセル
                    </button>
                    <button
                      class="btn btn-primary save-button"
                      type="button"
                      [disabled]="savingUserId != null"
                      (click)="save(viewModel)"
                    >
                      {{
                        savingUserId === viewModel.row.userId
                          ? '保存中...'
                          : '保存'
                      }}
                    </button>
                  </div>
                </div>
              }
            </article>
          }
        </div>
      }
    </div>
  }
</section>
